import React, { useState } from "react";
import { getStorage, ref, uploadBytes, getDownloadURL } from "firebase/storage";
import { v4 as uuidv4 } from "uuid";
import { FiTrash2 } from "react-icons/fi";

const storage = getStorage();

export default function EditPeopleForm({ people, type, onSave, onCancel }) {
    const [formList, setFormList] = useState(people);
    const [uploadingIndex, setUploadingIndex] = useState(null);

    const handleChange = (index, field, value) => {
        const updated = [...formList];
        updated[index][field] = value;
        setFormList(updated);
    };

    const handleImageUpload = async (index, file) => {
        if (!file || file.size > 1024 * 1024) return alert("Image too large (max 1MB)");

        setUploadingIndex(index);
        const fileRef = ref(storage, `people/${uuidv4()}_${file.name}`);
        const snap = await uploadBytes(fileRef, file);
        const url = await getDownloadURL(snap.ref);

        const updated = [...formList];
        updated[index].image = url;
        setFormList(updated);
        setUploadingIndex(null);
    };

    const handleDelete = (index) => {
        const confirmDelete = window.confirm("Are you sure you want to delete this entry?");
        if (!confirmDelete) return;
        const updated = formList.filter((_, i) => i !== index);
        setFormList(updated);
    };

    const addPerson = () => {
        const newEntry = type === "teacher"
            ? { name: "", title: "", position: "", image: "" }
            : { name: "", image: "" };
        setFormList([...formList, newEntry]);
    };

    const handleSubmit = (e) => {
        e.preventDefault();
        onSave(formList);
    };

    return (
        <form className="edit-form" onSubmit={handleSubmit}>
            <h4>Edit {type === "teacher" ? "Teachers" : "Students"}</h4>
            {formList.map((item, i) => (
                <div key={i} className="person-edit-row" style={{ borderBottom: "1px solid #ddd", paddingBottom: 12, marginBottom: 12 }}>
                    <div style={{ display: 'flex', gap: 10, alignItems: 'center' }}>
                        <input
                            value={item.name}
                            onChange={(e) => handleChange(i, "name", e.target.value)}
                            placeholder="Name"
                            style={{ flex: 1, padding: "6px 10px", borderRadius: 6, border: "1px solid #ccc" }}
                            required
                        />
                        {type === "teacher" && (
                            <input
                                value={item.title || ""}
                                onChange={(e) => handleChange(i, "title", e.target.value)}
                                placeholder="Title"
                                style={{ flex: 1, padding: "6px 10px", borderRadius: 6, border: "1px solid #ccc" }}
                            />
                        )}
                        {type === "teacher" && (
                            <input
                                value={item.position || ""}
                                onChange={(e) => handleChange(i, "position", e.target.value)}
                                placeholder="Position"
                                style={{ flex: 1, padding: "6px 10px", borderRadius: 6, border: "1px solid #ccc" }}
                            />
                        )}
                        <FiTrash2
                            onClick={() => handleDelete(i)}
                            style={{ cursor: "pointer", color: "crimson" }}
                            size={18}
                        />
                    </div>

                    <div style={{ marginTop: 8 }}>
                        <input
                            type="file"
                            accept="image/*"
                            onChange={(e) => handleImageUpload(i, e.target.files[0])}
                        />
                        {uploadingIndex === i && <span>Uploading...</span>}
                        {item.image && <img src={item.image} alt="preview" style={{ width: 100, marginTop: 8, borderRadius: 6 }} />}
                    </div>
                </div>
            ))}

            <button type="button" onClick={addPerson} style={{ marginTop: 10 }}>
                + Add {type === "teacher" ? "Teacher" : "Student"}
            </button>

            <div className="participation-buttons" style={{ marginTop: 16 }}>
                <button type="submit">Save</button>
                <button type="button" onClick={onCancel} style={{ marginLeft: 10 }}>Cancel</button>
            </div>
        </form>
    );
}
